export const input_type = {
  text: " form-control block w-full px-3 py-1.5 text-base font-normal   text-gray-700  bg-white bg-clip-padding  border border-solid border-gray-300 rounded-full transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none",
  number:
    "form-control block w-full  px-3  py-1.5  text-base  font-normal  text-gray-700  bg-white bg-clip-padding border border-solid border-gray-300  rounded-full  transition  ease-in-out  m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none",
  email:
    "form-control block w-full px-3 py-1.5 text-base font-normal text-gray-700 bg-white bg-clip-padding border border-solid border-gray-300 rounded-full transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none",
  wrapper: 'lg:mb-27 mb-15 xl:w-96 text-[15px]',
}

export const formInputStyle = {
  inputContainer: " ",
  labelStyle: "inline-block mb-[8px] text-[14px] md:text-[16px] leading-[22px] text-black tracking-[0.4px]  font-Bold ",
  text: "form-control block w-full py-[20px] px-[15px] text-[14px] leading-[21px] md:text-[16px] md:leading-[24px] font-Regular text-[#000]  bg-transparent bg-clip-padding  border border-[#a3a3a3]  rounded-[5px]  border-1 transition ease-in-out m-0 focus:text-gray-700 focus:bg-[#4f21701a] focus:border-[#000] focus:outline-none formInput",
  select:
    "form-select bg-dropDownArrow bg-no-repeat bg-right appearance-none block w-full p-14 text-base font-normal text-gray-700 bg-white bg-clip-padding bg-no-repeat  border border-solid  rounded-[25px] transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none bg-[94% center]  bg-[0% 96%]",
  chkWrpr: "flex my-20 odd:pb-20 relative",
  checkBox:
    "form-check-input before:h-[35px] before:w-[35px] absolute before:rounded-[0.3rem] before:bg-white custCheckBox before:absolute before:border-2  rounded-[20px] before:content-['']  focus:outline-none transition duration-200 mt-1 align-left bg-no-repeat bg-center bg-contain float-left mr-2 cursor-pointer formInput before:border-inputBrdr",
  checkBoxText:
    "inline-block p-5 text-[15px] leading-[21px] text-white lg:w-[455px]  lg:pr-0 w-full pl-50 aggrementCheckbox",
  error: "border-2 border-red-600 error",
  wrapper: 'lg:mb-27 mb-15 xl:w-96 text-[15px]',
}

export const defaultStyle = {
  inputContainer: "w-full",
  labelStyle: "inline-block mb-[8px] text-[14px] md:text-[16px] leading-[22px] text-black tracking-[0.4px]  font-Bold ",
  text: "form-control block w-full py-[20px] px-[15px] text-[16px] leading-[24px] font-Regular text-[#000]  bg-transparent bg-clip-padding  border border-[#a3a3a3]  rounded-[5px]  border-1 transition ease-in-out m-0 focus:text-gray-700 focus:bg-[#4f21701a] focus:border-[#000] focus:outline-none formInput",
  select: "",
  chkWrpr: "flex mb-20",
  checkBox: "",
  checkBoxText: "",
  error: "border-4 border-[#A52323] errorActive",
  wrapper: 'lg:mb-27 mb-15 xl:w-96 text-[15px]'
}

export const signUpStyle = {
  labelStyle: "inline-block text-sm mb-2 text-[#2b2b2b] font-bold",
  inputContainer: "lg:mb-3 mb-27 mt-40 xl:w-96",
  inputWrpr: " border-transparent border-solid border-2  inputShadow",
  text: "form-control block w-full py-13 px-20 text-base font-normal text-gray-700  bg-white bg-clip-padding   rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none",
  select: "",
  chkWrpr: "flex mb-20",
  checkBox: "",
  checkBoxText: "",
  error: "border-4 border-red-500",
  wrapper: 'lg:mb-27 mb-15 xl:w-96 text-[15px]',
}

export const RECIPE_SORTING = {
  wrapper: 'lg:mb-27 mb-15 xl:w-96 text-[15px]',
}

export const BANNER_WITH_FORM = {
  inputContainer: 'inputContainer w-[53%] md:w-auto',
  inputWrpr: "inputWrpr",
  text: "bg-[#fafafae3] border-0 border-b-1 border-solid border-[#666666] p-[5px] md:pl-[10px] text-[14px] md:text-[18px] placeholder-purple text-[#4f2170] inline-block w-full md:w-[670px] h-[30px] md:h-[50px] max-w-[100%]",
  select: "bg-[#fafafae3] border-0 border-b-1 border-solid border-[#666666] p-[5px] md:p-[10px] text-[14px] md:text-[18px] text-[#4f2170] inline-block w-full md:w-[350px] h-[30px] md:h-[50px] mr-[10px]",
  labelStyleWrapper: "lg:mb-27 md:mb-15 text-[15px]",
}
export const BANNER_WITH_FORM_LARGE_SCREEN = {
  ...BANNER_WITH_FORM
}
export const BANNER_IMAGE_VIDEO = {
  ...BANNER_WITH_FORM,
  inputContainer: 'inputContainer w-[53%] md:w-auto',
  inputWrpr: "inputWrpr",
  text: "bg-[#fafafae3] border-0 border-b-1 border-solid border-[#666666] p-[5px] md:pl-[10px] text-[14px] md:text-[18px] placeholder-purple text-[#4f2170] inline-block w-full md:w-[670px] h-[30px] md:h-[50px] max-w-[100%]",
  select: "bg-[#fafafae3] border-0 border-b-1 border-solid border-[#666666] p-[5px] md:p-[10px] text-[14px] md:text-[18px] text-[#4f2170] inline-block w-full md:w-[350px] h-[30px] md:h-[50px] mr-[10px]",
  labelStyleWrapper: "lg:mb-27 md:mb-15 text-[15px]",
}

export const careersSelect ={
  wrapper:'wrapper w-full',
  select:"selectDropdown w-full border border-[#a3a3a3] rounded-[5px] py-[20px] pl-[15px] !font-['Segoe_UI'] text-[16px]",
}

export const CAREER_JOBS_FORM = {
  inputContainer: 'inputContainer w-[53%] md:w-auto',
  inputWrpr: "inputWrpr",
  text: "bg-[#fafafae3] border-0 border-b-1 border-solid border-[#666666] p-[5px] md:pl-[10px] text-[14px] md:text-[18px] placeholder-purple text-[#4f2170] inline-block w-full md:w-[670px] h-[30px] md:h-[50px] max-w-[100%]",
  select: "bg-[#fafafae3] border-0 border-b-1 border-solid border-[#666666] p-[5px] md:p-[10px] text-[14px] md:text-[18px] text-[#4f2170] inline-block w-full md:w-[400px] h-[30px] md:h-[50px] mr-[10px]",
  labelStyleWrapper:"lg:mb-27 md:mb-15 text-[15px]",
  selectInputWrapper:"selectInputWrapper font-Regular text-[18px] text-[#4f2170] inline-block w-[400px] p-10 h-[50px] mr-10",
} 
